'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$11() {
  this.avC = null;
  this.avD = false;
}
export { $c_Lpresto_AgentView$$anon$11 as $c_Lpresto_AgentView$$anon$11 };
$p = $c_Lpresto_AgentView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$11;
/** @constructor */
function $h_Lpresto_AgentView$$anon$11() {
}
export { $h_Lpresto_AgentView$$anon$11 as $h_Lpresto_AgentView$$anon$11 };
$h_Lpresto_AgentView$$anon$11.prototype = $p;
$p.bY = (function() {
  if ((!this.avD)) {
    this.avC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.avD = true;
  }
  return this.avC;
});
$p.P = (function() {
  return this.bY();
});
var $d_Lpresto_AgentView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$11, "presto.AgentView$$anon$11", ({
  Dx: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$11 as $d_Lpresto_AgentView$$anon$11 };
//# sourceMappingURL=presto.-Agent-View$$anon$11.js.map
